import { PayAttempt } from "../stores/PayAttempt";

export const setMaxRoutingFeeAutomatically = (
  amount: number,
  payAttempt: PayAttempt
) => {
  let floor = null;
  if (amount <= 10) {
    floor = 3;
  } else {
    floor = 5;
  }
  /// nov 12 2025, change this to 1% due to high fees on lightning network
  const halfPercentCeil = (amount) => Math.ceil(amount * 0.01);
  payAttempt.maxRoutingFeeSatoshis = Math.max(halfPercentCeil(amount), floor);
};
